import { render } from "./Desktop.vue?vue&type=template&id=c7373992&scoped=true&bindings={\"backgroundBounce\":\"setup\",\"biosShow\":\"setup\",\"cartCount\":\"setup\",\"effectMirror\":\"setup\",\"effectShake\":\"setup\",\"initialize\":\"setup\",\"ready\":\"setup\",\"menuActive\":\"setup\",\"menuClose\":\"setup\",\"menuProps\":\"setup\",\"menuShow\":\"setup\",\"shutdown\":\"setup\",\"biosOnLoad\":\"setup\",\"threeSpace\":\"setup\",\"viewport\":\"setup\",\"windowDimensions\":\"setup\"}"
import script from "./Desktop.vue?vue&type=script&lang=ts"
export * from "./Desktop.vue?vue&type=script&lang=ts"

import "./Desktop.vue?vue&type=style&index=0&id=c7373992&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-c7373992"

export default script